<script>import Button from "../Button.svelte";
import ProgressIndicator from "../../ProgressIndicator.svelte";
import { attrValue } from "../../../../utils/html";
import IconLottie from "../../IconLottie.svelte";
export let props = {};
let buttonContainer;
$: size = props.size || "default";
$: props = {
  ...props,
  ref: props.ref ?? buttonContainer,
  classNames: attrValue([props.classNames ?? "", "inline-flex items-center"])
};
</script>

<Button
	{...$$restProps}
	{props}
	bind:this={buttonContainer}
	class="inline-flex items-center"
	on:click
>
	{#if props.fetching}
		<span class="absolute flex top-2/4 left-2/4 transform-gpu -translate-y-2/4 -translate-x-2/4">
			<ProgressIndicator appearance="circular" color={props.progressColor ?? 'white'} />
		</span>
	{/if}
	{#if props.iconLeft}
		<IconLottie
			name={props.iconLeft}
			classNames={attrValue([
				'flex-shrink-0',
				props.label ? 'mr-2' : '',
				props.fetching ? 'invisible' : ''
			])}
			animationOnLoad={props.animationOnLoad}
			size={props.iconSize ? props.iconSize : 'default'}
			parentRef={props.ref}
			keepOriginalColor={props.keepIconOriginalColor}
		/>
	{/if}
	{#if props.label}
		<span class="label {attrValue(['inline-block', size])}" class:invisible={props.fetching}>
			{props.label}
		</span>
	{/if}
	{#if props.iconRight}
		<IconLottie
			name={props.iconRight}
			animationOnLoad={props.animationOnLoad}
			classNames={attrValue([props.label ? 'ml-2' : '', props.fetching ? 'invisible' : ''])}
			size={props.iconSize ? props.iconSize : 'default'}
			parentRef={props.ref}
			keepOriginalColor={props.keepIconOriginalColor}
		/>
	{/if}
	<slot />
</Button>

<style>.label{word-wrap:anywhere}.tiny{font-size:.75rem}.small,.tiny{line-height:1rem}.small{font-size:.875rem}.default{font-size:1rem}.big,.default{line-height:1rem}.big{font-size:1.125rem}.huge{font-size:1.25rem}.giant,.huge{line-height:1rem}.giant{font-size:1.5rem}</style>
